<div class="p-4 flex-col flex gap-4">
    <!-- Header -->
    <div class="flex flex-col gap-1">
        <h3>
            <i class="pi pi-chart-pie text-amber-500"></i> 台電契約容量監測
        </h3>
        <div class="text-xs text-slate-500 flex items-center gap-1 pl-6">
            <i class="pi pi-clock"></i>
            <span>採樣時間 {{ sampledAt() | date:'yyyy/MM/dd HH:mm:ss' }}</span>
        </div>
    </div>

    <!-- Main Content -->
    <div class="rounded-xl p-4 shadow-sm flex flex-col gap-4 transition-colors duration-500"
         [ngClass]="isWarning() ? 'bg-red-50' : 'bg-green-50'">
        <div class="flex justify-between items-end px-1">
            <div class="flex flex-col gap-1">
                <span class="text-sm text-slate-500 font-bold">目前負載</span>
                <span class="text-3xl font-bold flex items-baseline gap-1"
                      [ngClass]="isWarning() ? 'text-red-500' : 'text-slate-800'">
                    {{ currentLoadKw() | number:'1.0-1' }}
                    <span class="text-base font-bold" [ngClass]="isWarning() ? 'text-red-400' : 'text-slate-500'">kW</span>
                </span>
            </div>

            <div class="flex flex-col gap-1 items-start">
                <span class="text-sm text-slate-500 font-bold">契約容量</span>
                <span class="text-3xl font-bold text-slate-700 flex items-baseline gap-1">
                    {{ (data()?.contractCapacityValue || 0) | number:'1.0-0' }}
                    <span class="text-base font-bold text-slate-600">kW</span>
                </span>
            </div>
        </div>

        <div class="px-1 flex flex-col gap-2">
            <div class="flex justify-between items-center text-base">
                <span class="text-slate-600 font-bold">使用率</span>
                <span class="font-bold" [ngClass]="isWarning() ? 'text-red-500' : 'text-green-600'">
                    {{ ratio() }}%
                </span>
            </div>

            <div class="w-full bg-slate-200 rounded-full h-2.5 overflow-hidden">
                <div class="h-full transition-all duration-500"
                    [ngClass]="isWarning() ? 'bg-red-500' : 'bg-green-500'"
                    [style.width.%]="ratio()">

                </div>
            </div>
        </div>
    </div>
</div>